import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/buttons/Button.vue';
import CloseButton from '@/components/buttons/dedicated/CloseButton.vue';
import InlineDialog from '@/components/info/InlineDialog.vue';
import { InlineDialogTheme } from '@/lib/enum/Colour';
import { Flag } from '@/lib/onboarding/onboardingFunctions';
import { goToLink } from '@/router/router';

interface Props {
  flag: Flag;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingDialogContent',
  props: {
    flag: null
  },
  emits: ["input", "actionClick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', v: boolean): void;
  (e: 'actionClick'): void;
}), expose: any, slots: any, attrs: any }) {




return { __sfc: true,emit, Button, CloseButton, InlineDialog, InlineDialogTheme, goToLink }
}

})